import { render, staticRenderFns } from "./_tag.vue?vue&type=template&id=99e576d6&scoped=true&"
import script from "./_tag.vue?vue&type=script&lang=js&"
export * from "./_tag.vue?vue&type=script&lang=js&"
import style0 from "./_tag.vue?vue&type=style&index=0&id=99e576d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/nuxt/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e576d6",
  null
  
)

export default component.exports